export const optimisticallyApplyReorderById = <T extends { id: string }>(
  lines: (T | null | undefined)[],
  orderedIdsOverride: string[] | null,
): (T | null | undefined)[] => {
  if (!orderedIdsOverride) {
    return lines;
  }

  const byId = new Map(
    lines.filter((line): line is T => Boolean(line)).map((line) => [line.id, line]),
  );
  const validOverrideIds = orderedIdsOverride.filter((id) => byId.has(id));
  if (validOverrideIds.length === 0) {
    return lines;
  }

  const overrideSet = new Set(validOverrideIds);
  const remainingIds = [...byId.keys()].filter((id) => !overrideSet.has(id));
  const newOrder = [...validOverrideIds, ...remainingIds];

  let cursor = 0;
  return lines.map((line) => {
    if (!line) {
      return line;
    }
    const replacementId = newOrder[cursor++]!;
    return byId.get(replacementId)!;
  });
};
